import React from "react";
import { Link, useParams } from "react-router-dom";
import "./App.css"; 
import { categories } from "./coverData";

const CoverList: React.FC = () => {
  // ZMIANA: Pobieramy tylko categoryId, bo pdfNameFromUrl już nie ma w routingu
  const { categoryId } = useParams<{ categoryId: string }>();

  // 1. Znajdź wybraną kategorię
  const category = categories.find((c) => c.id === categoryId);

  // ZMIANA: Usuwamy "!pdfNameFromUrl" z warunku błędu
  if (!category) {
    return (
      <div className="selection-container">
        <h2>Błąd: Nie znaleziono kategorii.</h2>
        <Link to="/start">Wróć do wyboru kategorii</Link>
      </div>
    );
  }

  // 2. Obliczanie wymiarów miniaturki
  const thumbWidth = 150;
  const scaleFactor = thumbWidth / category.thumbnailRatio.width;
  const thumbHeight = category.thumbnailRatio.height * scaleFactor;

  return (
    <div className="selection-container">
      <h1>{category.title}</h1>
      <p>Wybierz wzór okładki</p>
      
      <div className="grid-container">
        {category.covers.map((cover) => {
          // ZMIANA: Budujemy link bez doklejania pdfNameFromUrl na końcu
          const finalPath = cover.pathOverride 
            ? `${cover.pathOverride}`
            : `${category.basePath}/${cover.id}`;

          const imagePath = `/images/covers/${category.id}/${cover.id}.png`;
          
          return (
            <Link key={cover.id} to={finalPath} className="card cover-card">
              <img 
                src={imagePath}
                alt={`Miniatura ${cover.label}`}
                className="thumbnail-preview"
                style={{
                  width: `${thumbWidth}px`,
                  height: `${thumbHeight}px`,
                  objectFit: 'cover',
                  backgroundColor: '#f4f4f4',
                  border: '1px solid #ccc',
                  marginBottom: '10px',
                  borderRadius: '4px',
                  display: 'block'
                }}
                onError={(e) => {
                  (e.target as HTMLImageElement).src = 'https://placehold.co/150x200?text=Brak+foto';
                }}
              />
              
              <div className="card-label">
                <strong>{cover.label}</strong>
              </div>
            </Link>
          );
        })}
      </div>
    </div>
  );
};

export default CoverList;